import React from "react";
import "./tour7.css";
import { Link } from "react-router-dom";  
import { FaUmbrellaBeach, FaUsers,  FaMapMarkerAlt, FaEnvelope, FaPhone, FaHome, FaMountain, FaTree, FaMonument, FaTrain, FaCar, FaHotel } from "react-icons/fa";

function Tour7() {
  return (
    <section className="tour4-container">
        <div className="banner">
          <img 
            src="/explore srilanka.png" 
            alt="Airport Pickup and Drop Banner" 
            className="banner-image" 
          />
        </div>
      {/* Title */}
      <h1 className="tour4-title">7-Day Sri Lanka Cultural & Wildlife Expedition</h1>

      <div className="tour4-layout">
        {/* Left Section */}
        <div className="tour4-left">
          {/* Info Boxes */}
          <div className="tour4-info-cards">
            <div className="info-card">
              <FaUmbrellaBeach className="info-icon" />
              <div>
                <h4>Travel Duration</h4>
                <p>6 Nights, 7 Days</p>
              </div>
            </div>

            <div className="info-card">
              <FaUsers className="info-icon" />
              <div>
                <h4>Group Size</h4>
                <p>Family & Couples</p>
              </div>
            </div>

            <div className="info-card">
              <FaMapMarkerAlt className="info-icon" />
              <div>
                <h4>Destinations</h4>
                <p>Heritage & Wildlife</p>
              </div>
            </div>
          </div>

          {/* Tour Highlights */}
          <div className="tour4-highlights">
            <h3>Journey Highlights:</h3>
            <p>Discover the magnificent Sigiriya Rock, sacred Kandy temples, scenic hill country, and thrilling Yala National Park safari adventures.</p>

            <div className="tour4-gallery">
              <img src="/sigiriya.jpg" alt="Sigiriya Rock Fortress" />
              <img src="/polonnaruwa.jpg" alt="Polonnaruwa Ancient City" />
              <img src="/dambulla.jpg" alt="Dambulla Cave Temple" />
              <img src="/temple-of-the-sacred-tooth.jpg" alt="Temple of the Tooth" />
              <img src="/tea.jpg" alt="Tea Plantations" />
              <img src="/ella2.webp" alt="Ella Scenery" />
              <img src="/yala.jpg" alt="Yala National Park" />
              <img src="/nine-arch.jpg" alt="Nine Arches Bridge" />
              <img src="/galle-f.webp" alt="Galle Fort" />
              <img src="/Hill-Country.jpg" alt="Hill-Country" />
            </div>
          </div>

          {/* Itinerary */}
          <div className="tour4-itinerary">
            <h3>Day 1: Arrival and Sigiriya Exploration</h3>
            <ul>
              <li>Welcome at Bandaranaike International Airport</li>
              <li>Journey to the cultural heartland of Sigiriya</li>
              <li>Afternoon Activities:</li>
              <ul>
                <li>Ascend the legendary Sigiriya Rock Fortress, a UNESCO World Heritage marvel</li>
                <li>Marvel at ancient frescoes and royal palace ruins</li>
                <li>Capture breathtaking panoramic views from the summit</li>
              </ul>
              <li>Evening relaxation at your Sigiriya accommodation</li>
            </ul>

            <h3>Day 2: Ancient Kingdom of Polonnaruwa</h3>
            <ul>
              <li>Morning expedition to Polonnaruwa's archaeological wonders</li>
              <li>Historical Exploration:</li>
              <ul>
                <li>Discover the Royal Palace complex and ancient council chambers</li>
                <li>Admire the exquisite Gal Viharaya rock-cut Buddha statues</li>
                <li>Explore the massive Parakrama Samudraya ancient reservoir</li>
                <li>Optional bicycle tour through the archaeological park</li>
              </ul>
              <li>Return to Sigiriya for overnight stay</li>
            </ul>

            <h3>Day 3: Sacred Dambulla and Cultural Kandy</h3>
            <ul>
              <li>Morning visit to Dambulla Golden Cave Temple</li>
              <li>Journey to Kandy, the cultural capital</li>
              <li>Kandy Cultural Immersion:</li>
              <ul>
                <li>Witness traditional Kandyan dance performances</li>
                <li>Visit the sacred Temple of the Tooth Relic</li>
                <li>Stroll around Kandy Lake and explore the city center</li>
              </ul>
              <li>Overnight in Kandy with mountain views</li>
            </ul>

            <h3>Day 4: Hill Country Journey to Ella</h3>
            <ul>
              <li>Scenic drive through misty tea plantations to Nuwara Eliya</li>
              <li>Hill Country Experiences:</li>
              <ul>
                <li>Tour a working tea factory and sample world-famous Ceylon tea</li>
                <li>Explore Gregory Lake and colonial architecture</li>
                <li>Experience the stunning train journey from Nanu Oya to Ella</li>
              </ul>
              <li>Arrive in Ella for overnight stay</li>
            </ul>

            <h3>Day 5: Ella Adventures and Yala Safari</h3>
            <ul>
              <li>Morning exploration of Ella's natural wonders</li>
              <li>Ella Activities:</li>
              <ul>
                <li>Trek to Little Adam's Peak for magnificent valley views</li>
                <li>Visit the architectural marvel of Nine Arches Bridge</li>
                <li>Photograph stunning railway and mountain landscapes</li>
              </ul>
              <li>Afternoon transfer to Yala National Park</li>
              <li>Evening wildlife safari adventure</li>
              <li>Overnight near Yala National Park</li>
            </ul>

            <h3>Day 6: Coastal Heritage in Galle</h3>
            <ul>
              <li>Travel to the southern coast and Galle Fort</li>
              <li>Galle Exploration:</li>
              <ul>
                <li>Walk the ancient ramparts of UNESCO-listed Galle Fort</li>
                <li>Discover charming boutiques, art galleries, and cafes</li>
                <li>Visit the historic Galle Lighthouse</li>
                <li>Explore Dutch colonial architecture and museums</li>
              </ul>
              <li>Overnight in Galle or nearby coastal accommodation</li>
            </ul>

            <h3>Day 7: Coastal Relaxation and Departure</h3>
            <ul>
              <li>Morning beach relaxation and swimming</li>
              <li>Final Sri Lankan experiences:</li>
              <ul>
                <li>Enjoy traditional coastal cuisine</li>
                <li>Last-minute souvenir shopping</li>
                <li>Relax on pristine sandy beaches</li>
              </ul>
              <li>Afternoon transfer to airport for departure</li>
            </ul>
          </div>
        </div>

        {/* Right Sidebar */}
        <aside className="tour4-sidebar">
          <div className="sidebar-box">
            <h3>RESERVE YOUR ADVENTURE</h3>
            <p>
              Ready to embark on an unforgettable Sri Lankan journey? 
              Secure your cultural and wildlife expedition with <strong>Eco Rich Travels</strong>.
            </p>
            <Link to="/bookings" style={{ textDecoration: 'none' }}>
              <button className="btn-primary">BOOK THIS TOUR</button>
            </Link>
          

                       <button 
            className="btn-secondary"
            onClick={() => window.open(`https://wa.me/94742947134`, '_blank')}
          >
            Get Custom Quote
          </button>
          
          </div>

          <div className="sidebar-box contact-box">
            <h3>PLAN YOUR JOURNEY</h3>
            <p>
              Have questions about this itinerary or need customization? 
              Our travel experts are here to create your perfect adventure.
            </p>

            <div className="contact-details">
              <p><FaEnvelope /> info@ecorichtravels.com</p>
              <p><FaPhone /> +94 74 294 7134</p>
              <p><FaHome /> 520, Pamunugama Rd, Negombo</p>
            </div>
          </div>

          <div className="sidebar-box">
            <h3>TOUR INCLUSIONS</h3>
            <div className="contact-details">
              <p><FaMonument /> All Heritage Site Entrances</p>
              <p><FaTree /> National Park Safari Fees</p>
              <p><FaTrain /> Scenic Train Journey</p>
              <p><FaMountain /> Guided Mountain Treks</p>
              <p><FaHotel /> 6 Nights Accommodation</p>
              <p><FaCar /> Private Transport Throughout</p>
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}

export default Tour7;